import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Copyright from '../../internals/components/Copyright';
import TransitionMark from '../../../Transitions/TransitionMark';
import IframeDisplay from './IframeDisplay';

export default function MainGridGames({ category }) {
  return (
    <>
      <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
        <Grid
          container
          spacing={2}
          columns={12}
          sx={{ mb: (theme) => theme.spacing(2) }}
        >
          <IframeDisplay category={category} />
        </Grid>
        <Copyright sx={{ my: 4 }} />
      </Box>
    </>
  );

};

